'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-929adab5.js');
var React = require('react');
var styled = require('styled-components');
var components_Body2_index = require('../Body2/index.js');
var FormControlLabel = require('@mui/material/FormControlLabel');
var MuiRadio = require('@mui/material/Radio');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var FormControlLabel__default = /*#__PURE__*/_interopDefaultLegacy(FormControlLabel);
var MuiRadio__default = /*#__PURE__*/_interopDefaultLegacy(MuiRadio);

var StyledFormControlLabel = styled__default["default"](FormControlLabel__default["default"])(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  gap: 11px;\n  margin: 5px 0;\n"], ["\n  gap: 11px;\n  margin: 5px 0;\n"])));
var LabelText = styled__default["default"](components_Body2_index["default"])(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  display: inline-block;\n  margin-left: 5px;\n"], ["\n  display: inline-block;\n  margin-left: 5px;\n"])));
var StyledRadio = styled__default["default"](MuiRadio__default["default"])(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  background-color: ", ";\n\n  :hover,\n  &.Mui-checked:hover {\n    background-color: ", ";\n  }\n  &.Mui-checked {\n    background-color: ", ";\n  }\n  padding: 6px;\n  box-shadow: ", ";\n  .MuiSvgIcon-root {\n    fill: white;\n    border-radius: 50%;\n    background-color: white;\n    height: 7px;\n    width: 7px;\n  }\n"], ["\n  background-color: ", ";\n\n  :hover,\n  &.Mui-checked:hover {\n    background-color: ", ";\n  }\n  &.Mui-checked {\n    background-color: ", ";\n  }\n  padding: 6px;\n  box-shadow: ", ";\n  .MuiSvgIcon-root {\n    fill: white;\n    border-radius: 50%;\n    background-color: white;\n    height: 7px;\n    width: 7px;\n  }\n"])), function (_a) {
    var light = _a.theme.colors.text.light;
    return light;
}, function (_a) {
    var checked = _a.checked, action = _a.theme.colors.button.action;
    return (checked ? action : 'transparent');
}, function (_a) {
    var checked = _a.checked, action = _a.theme.colors.button.action;
    return (checked ? action : 'transparent');
}, function (_a) {
    var shadows = _a.theme.shadows;
    return shadows[9];
});
// private component
var Radio = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, checked = _a.checked, children = _a.children, disabled = _a.disabled, name = _a.name, value = _a.value;
    return (React__default["default"].createElement(StyledFormControlLabel, { className: className, ref: ref, value: value, control: React__default["default"].createElement(StyledRadio, { checked: checked, name: name, disabled: disabled }), label: React__default["default"].isValidElement(children) ? (children) : (React__default["default"].createElement(LabelText, null, children)) }));
});
var templateObject_1, templateObject_2, templateObject_3;

exports["default"] = Radio;
